export default "recent-legendary-levels = 最近新增的传奇关卡\nlink-quality-guideline = 关于Hidden和Unlisted的说明\nlink-usage = 论坛使用指南\n"